namespace RedBullMOBILE360.SMSCodes {
    export namespace SubscriptionCodesService {
        export const baseUrl = 'SMSCodes/SubscriptionCodes';

        export declare function Create(request: Serenity.SaveRequest<SubscriptionCodesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SubscriptionCodesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SubscriptionCodesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SubscriptionCodesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SMSCodes/SubscriptionCodes/Create",
            Update = "SMSCodes/SubscriptionCodes/Update",
            Delete = "SMSCodes/SubscriptionCodes/Delete",
            Retrieve = "SMSCodes/SubscriptionCodes/Retrieve",
            List = "SMSCodes/SubscriptionCodes/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SubscriptionCodesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
